import React from 'react';
import PageLayout from '../components/Layout/PageLayout';
import KPIProductionResult from "../components/ProductionManagement/KPIProductionResult";

const KPIProductionResultPage = (props) => {
  const tabId = props.tabId || 'mm-kpi-result-in';

  return (
      <PageLayout>
          <KPIProductionResult tabId={tabId} />
      </PageLayout>
  );
};

export default KPIProductionResultPage;